import React from 'react'
import PropTypes from 'prop-types'

import { HeaderTwo } from 'secondstep-components'
import {
  CardContainer,
  CardSectionDescription,
  StyledTooltip,
  TitleAndToolTipContainer,
} from './component.styles'
import ResourceCard from 'experienceComponents/ResourceCard'
import {
  getCollectionResourceValues,
  getLabelBasedOnLocation,
} from 'utils/highschoolHelpers'

export const CardSection = ({
  headerText,
  description,
  resources,
  onClick,
  tooltips,
  tooltipLabel,
  isSingleCard = false,
  isWideCards = false,
}) => {
  return (
    <>
      <TitleAndToolTipContainer>
        <HeaderTwo className="integratedHeader">
          {headerText}
          <StyledTooltip
            content={getLabelBasedOnLocation(tooltips, tooltipLabel)}
          >
            <i className="fas fa-question-circle" />
          </StyledTooltip>
        </HeaderTwo>
      </TitleAndToolTipContainer>
      {description && (
        <CardSectionDescription>{description}</CardSectionDescription>
      )}
      <CardContainer isSingleCard={isSingleCard} isWideCards={isWideCards}>
        {resources?.map((resource, index) => {
          const resourceValues = getCollectionResourceValues(resource)

          const {
            audiences,
            grades,
            resourceTypes,
            durations,
            units,
          } = resourceValues
          return (
            <ResourceCard
              audience={audiences}
              description={resource?.description}
              duration={durations}
              grade={grades}
              image={resource?.image?.url}
              imageDescription={resource?.image?.description}
              isSingleCard={isSingleCard}
              isWideCards={isWideCards}
              key={index}
              onClick={() => onClick(resource.routeSlug)}
              resourceType={resourceTypes}
              shouldShowStatusIcon={false}
              title={resource?.displayTitle}
              unit={units}
            />
          )
        })}
      </CardContainer>
    </>
  )
}

CardSection.propTypes = {
  description: PropTypes.string,
  headerText: PropTypes.string,
  isSingleCard: PropTypes.bool,
  isWideCards: PropTypes.bool,
  onClick: PropTypes.func,
  resources: PropTypes.arrayOf(PropTypes.object),
  tooltipLabel: PropTypes.string.isRequired,
  tooltips: PropTypes.array,
}

export default CardSection
